import AppEvent from 'src/models/AppEvent';
var Events = /** @class */ (function () {
    function Events() {
    }
    Events.taskDialogClosed = new AppEvent();
    return Events;
}());
export { Events };



//////////////////
// WEBPACK FOOTER
// ./src/services/Events.ts
// module id = 299
// module chunks = 0